import {IGetClassEventsRequest, IGetDropInPriceRequest, IGetDropInPriceResponse} from "../models/ClassEvent";
import {$clientApi} from "../http";

class ClassEventServiceClass {

    async getClassEventsByDate(model: IGetClassEventsRequest) {
        return $clientApi.get(`api/class-events?start=${model.start}&end=${model.end}`)
    }

    async getPublicClassEventsByDate(model: IGetClassEventsRequest) {
        return $clientApi.get(`api/public/class-events?start=${model.start}&end=${model.end}`)
    }

    async getEventDetailById(eventId: number) {
        return $clientApi.get<any>(`api/class-events/registration-view-model-web/${eventId}`);
    }

    async checkIAmRegistered(eventId: number) {
        return $clientApi.get<any>(`api/class-events/register-my-user/${eventId}`);
    }

    async addDropIn(classEventId: number, customerId: number, price: string, couponCode: null | string, loyaltyExchangeId: number | null) {
        return $clientApi.post<{success?: boolean, error?: {message: string}}>(`api/drop-in`, {customerId, classEventId, price, couponCode, loyaltyExchangeId});
    }

    async addMemberToEvent(eventIds: number[], customerId: number) {
        return await $clientApi.post(`api/class-events/register-user`, {
            eventIds,
            userId: customerId
        });
    }

    async getDropInPrice(model: IGetDropInPriceRequest) {
        let queryParams = `classEventId=${model.classEventId}`;
        if (model.loyaltyExchangeId) {
            queryParams += `&loyaltyExchangeId=${model.loyaltyExchangeId}`
        }
        if (model.couponCode) {
            queryParams += `&couponCode=${model.couponCode}`
        }
        return $clientApi.get<IGetDropInPriceResponse>(`api/drop-in/price?${queryParams}`)
    }
}

export const ClassEventService = new ClassEventServiceClass();